import React, { useState, useEffect } from 'react';
import { PHP_API } from '../../../../utils/Common';
import axios from 'axios';
import Post from '../../../../utils/Post';
import { generarExcel } from '../../../sharecomponents/ExcelUtilities';

const ResumenMetasDescarga = (p) => {
    const [loader, setloader] = useState(false);
    const [semanas, setsemanas] = useState([]);
    const [selected, setselected] = useState({});
    const [selecciones, setselecciones] = useState({ semana: "siembra", flor: "", variedad: "", color: "" });
    const [filtros, setfiltros] = useState({ flores: [], variedades: [], colores: [], semanas: [], trasplante: [], cosecha: [], tipos_semanas: [{ semana: "siembra" }, { semana: "trasplante" }, { semana: "cosecha" }] });
    const keys = [{ key: 'tipos_semanas', name: 'semana' }, { key: 'flores', name: 'flor' }, { key: 'variedades', name: 'variedad' }, { key: 'colores', name: 'color' }];
    useEffect(() => {
        get_semanas();
    }, []);

    const get_semanas = () => {
        setloader(true);
        Post("api/genPlanesData").then((r) => {
            setloader(false);
            setsemanas(r.data.semanas);
            setfiltros({ ...r.data, tipos_semanas: [{ semana: "siembra" }, { semana: "trasplante" }, { semana: "cosecha" }] });
        })
            .catch((e) => setloader(false));
    }

    const seleccionar = (index) => {
        let s = { ...selected };
        if (s[index]) delete s[index];
        else s[index] = true;
        setselected(s);
    }

    const descargar = async (bd = undefined) => {
        let indexes = Object.keys(selected);
        if (indexes.length === 0) return;

        let sm = [];
        for (let i = 0; i < indexes.length; i++) {
            sm.push(semanas[indexes[i]].semana);

        }

        let resp = await Post("api/resumen_plan_semanas", { semanas: sm, bd: bd, ...selecciones });
        if (resp.estatus) {
            formatData(resp.data, bd);
        } else {
            //Dialog
        }

    }

    const formatData = (data, bd = false) => {
        let totales_acumulado = { " - ": "-", 'Total plantas': 0, 'Total tallos': 0 };
        let format = bd ? data : [];
        if (!bd) {
            let flores = Object.keys(data);
            for (let i = 0; i < flores.length; i++) {
                let flor = flores[i];
                let semanas = [];
                let variedades = Object.keys(data[flor]);

                for (let j = 0; j < variedades.length; j++) {
                    let variedad = variedades[j];
                    let colores = Object.keys(data[flor][variedad]);

                    for (let k = 0; k < colores.length; k++) {
                        let color = colores[k];
                        let insert = {};
                        if (revisarFlor(flor, format)) insert.Flor = '-';
                        else insert.Flor = flor;

                        if (k === 0) {
                            insert.Variedad = variedad;
                        } else insert.Variedad = '--';

                        insert.Color = color;
                        semanas = Object.keys(data[flor][variedad][color]);
                        let totales = { plantas: 0, tallos: 0 };
                        for (let l = 0; l < semanas.length; l++) {
                            let semana = semanas[l];
                            insert[semana + " Plantas"] = data[flor][variedad][color][semana].plantas;
                            insert[semana + " Tallos"] = data[flor][variedad][color][semana].tallos;

                            totales.plantas += data[flor][variedad][color][semana].plantas;
                            totales.tallos += data[flor][variedad][color][semana].tallos;
                        }
                        insert[" - "] = " ";
                        insert['Total plantas'] = totales.plantas;
                        insert['Total tallos'] = totales.tallos;
                        totales_acumulado['Total plantas'] += totales.plantas;
                        totales_acumulado['Total tallos'] += totales.tallos;
                        format.push(insert);
                    }
                }
                let res = sumatoriaFlorSemana(flor, semanas, format, totales_acumulado);
                format = res.format;
                totales_acumulado = res.totales;


            }
            format.push({});
            format.push(totales_acumulado);
        }

        generarExcel(format, bd ? 'BD_plan_siembra' : 'RESUMEN_SEMANAS_PLAN_SIEMBRA')

    }

    const revisarFlor = (flor, format) => {
        for (let i = 0; i < format.length; i++) {
            if (format[i].Flor === flor) return true;
        }
        return false;
    }

    const sumatoriaFlorSemana = (flor, semanas, format, general) => {
        if (!general.Flor) {
            general.Flor = "Total por semana";
            general.Variedad = "-";
            general.Color = "-";
            for (let i = 0; i < semanas.length; i++) {
                let plantas = semanas[i] + " Plantas", tallos = semanas[i] + " Tallos";
                general[plantas] = 0;
                general[tallos] = 0;
            }
        }
        let i_inicio = 0, i_fin = 0;
        let vacio = { Flor: "", Variedad: "", Color: "" }

        for (let i = 0; i < format.length; i++) {
            if (format[i].Flor === flor) i_inicio = i;
            else if (i_inicio > 0 && format[i].Flor !== "-" && format[i].Flor !== flor) i_fin = i;
        }
        if (i_fin === 0) i_fin = format.length - 1;
        let totales = { Flor: "Total de " + flor, Variedad: "", Color: "" };
        for (let i = 0; i < semanas.length; i++) {
            let plantas = semanas[i] + " Plantas", tallos = semanas[i] + " Tallos";
            totales[plantas] = 0;
            totales[tallos] = 0;
            vacio[plantas] = "";
            vacio[tallos] = "";

            for (let j = i_inicio; j <= i_fin; j++) {
                totales[plantas] += format[j][plantas];
                totales[tallos] += format[j][tallos];
                general[plantas] += format[j][plantas];
                general[tallos] += format[j][tallos];
            }
        }

        totales[" - "] = " ";
        totales['Total plantas'] = "";
        totales['Total tallos'] = "";
        vacio[" - "] = " ";
        vacio['Total plantas'] = "";
        vacio['Total tallos'] = "";
        format.push(totales);
        format.push(vacio);
        format.push(vacio);
        return { format: format, totales: general };
    }

    const handleChange = (e) => {
        if (e.target.name === 'semana') {
            setselected({});
            let semanasParser = { 'siembra': 1, 'trasplante': 2, 'cosecha': 3 }
            let value = e.target.value === "" ? 1 : semanasParser[e.target.value];
            semanasParser = { 1: 'semanas', 2: 'trasplante', 3: 'cosecha' };
            setsemanas(filtros[semanasParser[value]]);
        }
        setselecciones({ ...selecciones, [e.target.name]: e.target.value });
    }


    return (
        <div className='vh-100 vw-100 blur-s m-0 p-2 bg-white4' style={{ position: 'fixed', top: 0, left: 0, zIndex: 2, overflow: 'auto' }}>
            <div className='row justify-content-evenly w-100 m-0 p-0 mt-5'>
                <div className='col-lg-10 text-end m-2 p-2 mt-5'>
                    <button className='btn btn-lg btn-danger scale-continue-05 shadow border border-dark border-3 round-xxl' onClick={p.close} >Cerrar</button>
                </div>
                <div className='col-lg-10 round-s shadow p-3 m-0 bg-white'>
                    <div className='row justify-content-evenly w-100'>
                        {keys.map((d, j) => <div className='form-group bw-200 mt-2' key={"form" + d.key}>
                            <label className="text-bold w-100 text-start">{d.key.toUpperCase().replace('_', ' ')}</label>
                            <select className="form-control form-control-sm"
                                name={d.name} value={selecciones[d.name] ?? 0}
                                onChange={handleChange} >
                                {d.name !== "semana" && <option value={""}>Todos los resultados</option>}
                                {filtros[d.key].map((f, i) =>
                                    <option key={i + d.key + d.name} value={f[d.name]}>{(f[d.name] ?? "").toUpperCase()} </option>)
                                }
                            </select>
                        </div>
                        )}

                        <div className='w-100 ms-0 me-0 mt-0 mt-3 mb-2 h3 dosis text-center'>
                            Pulse sobre las semanas que desea descargar, vuelva a pulsar para eliminar la selección
                        </div>
                        <div className='w-100 mb-5 p-0 text-center'>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                <button className='btn btn-sm btn-light border border-info border-2 round-xxl text-bold contenedor shadow bw-150' disabled={Object.keys(selected).length === 0} onClick={() => { descargar(false) }}>
                                    <i class="fas fa-file-download me-2 text-l"></i>
                                    Reporte
                                </button>
                                <button className='btn btn-sm btn-light border border-warning border-2 round-xxl text-bold contenedor shadow bw-150' disabled={Object.keys(selected).length === 0} onClick={() => { descargar(1) }}>
                                    <i class="fas fa-file-download me-2 text-l"></i>
                                    Base de datos
                                </button>
                            </div>
                        </div>
                        {
                            semanas.map((sem, i) =>
                                <button key={i} className={' bw-100 btn p-1 m-2 ' + (selected[i] ? "btn-warning" : "btn-light shadow")} onClick={() => { seleccionar(i) }}>
                                    {sem.semana}
                                </button>)
                        }

                        <div className='w-100 mt-4 mb-3 p-0 text-center'>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                <button className='btn btn-lg btn-light border border-info border-2 round-xxl text-bold contenedor shadow bw-200 text-l' disabled={Object.keys(selected).length === 0} onClick={() => { descargar(false) }}>
                                    <i class="fas fa-file-download me-2 text-xxl"></i>
                                    Reporte
                                </button>
                                <button className='btn btn-lg btn-light border border-warning border-2 round-xxl text-bold contenedor shadow bw-200 text-l' disabled={Object.keys(selected).length === 0} onClick={() => { descargar(1) }}>
                                    <i class="fas fa-file-download me-2 text-xxl"></i>
                                    Base de datos
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResumenMetasDescarga;